import { Link } from "@/i18n/routing";
import { IconCartFailed, IconCartFailedMobile } from "@repo/assets/images";
import { Button } from "@repo/ui";

const OrderRetrieveFailure = ({ t }) => {
  return (
    <div className="relative mx-auto min-h-screen py-[22px] md:max-w-screen-xl">
      <div className="border-supportiveDarkGray mx-auto px-4 py-6 md:max-w-[628px] md:border">
        <>
          <IconCartFailed className="fill-icon-bg text-icon-color mx-auto hidden md:block" />
          <IconCartFailedMobile className="fill-icon-bg text-icon-color mx-auto md:hidden" />
        </>
        <h1 className="font-heading rtl:font-arabic mx-auto py-6 text-center text-xl md:text-2xl">
          {t("Your_Order_Status_Could_Not_Be_Retrieved")}
        </h1>
        <div className="mt-6">
          <div className="grid w-full grid-cols-2 gap-4">
            <Link href="/">
              <Button variant="secondary" className="w-full" size="md">
                {t("Take_Me_Home")}
              </Button>
            </Link>
            <Link href="/account/orders">
              <Button variant="primary" className="w-full" size="md">
                {t("View_My_Orders")}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrderRetrieveFailure;
